<template>
    <main class="main frame-medium">

        <h2 class="main__headline remove-t-margin">{{data.title}}</h2>
        <div v-html="data.content"></div>
    </main>
</template>


<script>
    export default {
        name: "Info",
        props: {
            data: Object
        },
    }
</script>

<style scoped>

</style>
